import React from "react";
import { Jumbotron } from "./migration";

const AboutMe = ({ heading, message, resume }) => {
  return (
    <Jumbotron id="aboutme" className="m-0">
      <h2 className="section-heading mb-4">{heading}</h2>
      <p className="lead section-text">{message}</p>
      {resume && (
        <a
          className="text-link"
          href={resume}
          target="_blank"
          rel="noreferrer noopener"
          aria-label="Resume/CV"
        >
          View resume &rarr;
        </a>
      )}
    </Jumbotron>
  );
};

export default AboutMe;
